/**
 * List of available language codes.
 */
export const languageCodes = [
    'en',
    'nl'
] as const;

/**
 * Set of available language codes for fast lookup.
 */
export const languageCodesSet: Set<LanguageCode> = new Set(languageCodes);

/**
 * Available language codes for the application.
 * Do note that this does not mean that translations exist for all these languages.
 * It only indicates which languages MAY be available.
 * If a translation does not exist for a certain language, the fallback language will be used.
 */
export type LanguageCode = typeof languageCodes[number];

/**
 * Array of available language codes.
 */
export type LanguageCodes = readonly LanguageCode[];

/**
 * Fallback language if the language query parameter is missing or invalid
 */
export const fallbackLanguage: LanguageCode = 'nl';